export default "__VITE_ASSET__6J65q1K$__"